
export const getLocations = async () => {
    let res = await fetch(`${process.env.PREACT_APP_API_URL}api/get-locations`, {mode: "cors"});
    res = await res.json();
    return res
}

export const getSalons = async (countryId, cityId, areaId, hairServiceSlug, searchParam, page, perPage, captchaToken) => {
    let url = `${process.env.PREACT_APP_API_URL}api/get-salons?page=${page}&per_page=${perPage}`
    if (countryId) {
        url += `&countryId=${countryId}`
    }
    if (hairServiceSlug) {
        url += `&hairServiceSlug=${hairServiceSlug}`
    }
    if (cityId) {
        url += `&cityId=${cityId}`
    }
    if (areaId) {
        url += `&areaId=${areaId}`
    }
    if (searchParam) {
        url = url.replace('get-salons', 'get-salons-by-keyword')
        url += `&searchParam=${searchParam}&captchaToken=${captchaToken}`
    }
    let res = await fetch( url, {mode: "cors"});
    res = await res.json();
    return res
}

export const getPopularStylists = async (count = 6, countryName = null) => {
    let url = `${process.env.PREACT_APP_API_URL}api/website/get-popular-stylists?count=${count}`
    if (countryName) {
        url += `&countryName=${countryName}`
    }
    const response = await fetch(url);
    const json = await response.json();
    if (response.status === 200 || response.status === 201) {
        return {
            responseCode: response.status,
            success: true,
            data: json.data,
        };
    }
}